import { questionTypes } from 'Interfaces/Forms/QuestionInterface';
import './Style.scss';
import { Filter } from 'lucide-react';
import * as React from 'react';
import Select from 'react-select';
import FormUtils from 'views/SingleInstance/utils/FormUtils';
import { getLocalization } from 'global/global';

interface Props {
  questions: string[];
  formUtils: FormUtils | null;
  filterValues: string[];
  setFilter: (filter: {[key: string]: string[]}) => void;
}

export default function KanbanFilter(props: Props) {
  const { questions, formUtils, filterValues } = props;

  const [selected, setSelected] = React.useState({});

  const updateSelected = (id: string, v: string[]) => {
    const newSelected = {...selected};
    newSelected[id] = newSelected[id] || [];
    newSelected[id] = v;
    setSelected(newSelected);
    props.setFilter(newSelected);
  };

  React.useEffect(() => {
    setSelected({});
  }, [questions]);

  const getFormSelect = React.useCallback((questionId: string) => {
    if (formUtils) {
      const qn = formUtils.getQuestion(questionId);
      if (qn) {
        let listItems;
        if (qn.type === questionTypes.LOOKUP_VALUES_QUESTION) {
          const options = formUtils.getLookupOptions(questionId);
          listItems = Object.keys(options).map(v => ({ label: v, value: v, isDisabled: !filterValues.includes(v)}));
          listItems.shift();
        } else if (qn.validatefield && qn.validationlist) {
          listItems = qn.validationlist.split(';').map(s => {
            if (s.trim() !== '') {
              return { label: s.trim(), value: s.trim(), isDisabled: !filterValues.includes(s.trim()) };
            } else {
              return null;
            }
          }).filter(s => s !== null);
        }
        if (listItems) {
          const value = selected[questionId] || [];
          const _selected = listItems.filter(v => value.indexOf(v.value) > -1);
          return (
            <Select
              isMulti={true}
              options={listItems}
              isSearchable={true}
              className={'me-3 filter-dropdown'}
              value={_selected}
              placeholder={qn.text}
              onChange={(newItem) => {
                if (newItem) {
                  if (Array.isArray(newItem)) {
                    updateSelected(questionId, newItem.map(i => i.value));
                  } else {
                    updateSelected(questionId, [newItem.value]);
                  }
                }
              }}
            />
          );
        }
      }
    }
    return null;
  }, [questions, selected, filterValues]);

  return questions.length ? (
    <div className="d-flex kanban-filter shadow-sm p-3 mb-3 align-items-center">
      <div className="d-flex gap-2 me-3">
        <Filter size={16}/>
        <span className="filter-text">{getLocalization('filterBy')}</span>
      </div>
      {questions.map(id => getFormSelect(id))}
    </div>
  ) : null;
}
